import { PARAGRAPH_MAX_LENGTH } from '@record-fill';

export const FORM_FIELD_CHARACTER_LIMITS = {
  FIELD_ID: 100,
  VALUE: 200,
  FIXED_TEXT: 200,
  PARAGRAPH_VALUE: PARAGRAPH_MAX_LENGTH,
  AUXILIARY_TEXT: 200,
  LABEL: 200,
  TOOLTIP: 100,
  LOG_FIELD_NAME: 100,
} as const;
